import {
    EmployeeAccrualProfileCreate,
    EmployeeAccrualProfile,
    EmployeeAccrualProfileUpdate,
    AssignProfiles
}
from  "./@types/AccrualProfileEmployee";

export class EmployeeAccrualProfileRepository {
    private httpService: IHttpService;
    private baseUrl: string;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/accrual_profiles_employee';
    }

    async getAll(employee_id: number): Promise<EmployeeAccrualProfile[]> {
        const response = await this.httpService.get<TKResponse<EmployeeAccrualProfile[]>>(`${this.baseUrl}?employee_id=${employee_id}`);
        return response.data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
    }

    async create(data: EmployeeAccrualProfileCreate | EmployeeAccrualProfileCreate[]): Promise<EmployeeAccrualProfile | EmployeeAccrualProfile[]> {
        const response = await this.httpService.post<TKResponse<EmployeeAccrualProfile | EmployeeAccrualProfile[]>, EmployeeAccrualProfileCreate | EmployeeAccrualProfileCreate[]>(this.baseUrl, {data});
        return response.data;
    }

    async update(employee_id: number, data: AssignProfiles):  Promise<EmployeeAccrualProfileUpdate | EmployeeAccrualProfileUpdate[]> {
        const response = await this.httpService.patch<TKResponse<EmployeeAccrualProfileUpdate | EmployeeAccrualProfileUpdate[]>, AssignProfiles>(`${this.baseUrl}/${employee_id}`, {data});
        return response.data;
    }
}
